import { MobileGenreStrip } from './MobileDiscovery';
import Catalog from "./Catalog";
import React, { useState, useEffect } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import SeriesCarouselComponent from "./seriescarosal";
import Searchresult from "./search";
import Api_key from "./apiconfiguration";
import GlassLoading from "./GlassLoading";
import useLoadTransition from "./useLoadTransition";

const SeriesComponent = ({ search }) => {
  const [selectedGenre, setSelectedGenre] = useState('All');
  const [seriesByCategory, setSeriesByCategory] = useState({});
  const [loading, setLoading] = useState(true);
  const { showLoader, isContentVisible } = useLoadTransition(loading);
  const [error, setError] = useState(null);
  const apiKey = Api_key;


  const genres = [
    { id: 10759, name: "Action & Adventure" },
    { id: 16, name: "Animation" },
    { id: 35, name: "Comedy" },
    { id: 80, name: "Crime" },
    { id: 99, name: "Documentary" },
    { id: 18, name: "Drama" },
    { id: 10751, name: "Family" },
    { id: 10762, name: "Kids" },
    { id: 9648, name: "Mystery" },
    { id: 10763, name: "News" },
    { id: 10764, name: "Reality" },
    { id: 10765, name: "Sci-Fi & Fantasy" },
    { id: 10766, name: "Soap" },
    { id: 10767, name: "Talk" },
    { id: 10768, name: "War & Politics" },
    { id: 37, name: "Western" }
  ];

  useEffect(() => {
    const fetchSeries = async () => {
      try {
        const [genreResponses, latestSeriesResponse] = await Promise.all([
          Promise.all(
            genres.map((genre) =>
              axios.get(
                `https://api.themoviedb.org/3/discover/tv?api_key=${apiKey}&with_genres=${genre.id}&page=1`
              )
            )
          ),
          axios.get(
            `https://api.themoviedb.org/3/tv/on_the_air?api_key=${apiKey}&page=1`
          ),
        ]);

        const categoryResults = genres.reduce((results, genre, index) => {
          results[genre.name] = genreResponses[index].data.results || [];
          return results;
        }, {});
        categoryResults["Latest Releases"] =
          latestSeriesResponse.data.results || [];

        setSeriesByCategory(categoryResults);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchSeries();
  }, []);

  if (error) return <p>Error loading series: {error}</p>;
  return (
    <div className="page-stage">
      {showLoader && (
        <div className={`page-loader-layer ${loading ? "" : "is-exiting"}`}>
          <GlassLoading variant="catalog" label="Loading series collections" />
        </div>
      )}
      <div className={`page-reveal ${isContentVisible ? "is-visible" : ""}`}>
      {search ? (
        <Searchresult search={search} />
      ) : (
        <>
          <MobileGenreStrip categories={seriesByCategory} selected={selectedGenre} onSelect={setSelectedGenre} />
          <SeriesCarouselComponent selection={selectedGenre === 'All' ? null : seriesByCategory[selectedGenre]?.slice(0,7)} />
          <Catalog categories={seriesByCategory} mediaType="tv" selectedGenre={selectedGenre} onGenreChange={setSelectedGenre} />
        </>
      )}
      </div>
    </div>
  );
};

export default SeriesComponent;
